export default {
	name: "PlatformBillInvalid",
	conditionData: '',
	created: function () {
		this.init();
	},
	data() {
		return {
			billInvalidForm: {
				applyText: '',
				invalidRadio: '',
				destructionList: [],
				guaranteeList: []
			},
			isCheckArray: [],
			fileExpressRefVo: [],
			destruction: null,
			guarantee: null,
			rules: {
				invalidRadio: [
					{
						required: true, //是否必填
						message: this.$t('c_billInvalid.invalidRadioMassage'), //提示信息
						trigger: 'blur'  //何事件触发
					}
				],
				destructionList: [
					{ required: true, message: this.$t('c_billInvalid.destroyRecordsNull'), trigger: 'change' }
				],
				guaranteeList: [
					{ required: true, message: this.$t('c_billInvalid.scrapBondNull'), trigger: 'change' }
				]
			}
		}
	},
	watch: {
		"billInvalidForm.invalidRadio"(value) {
			if (value === 1) {
				this.isCheckArray = new Array(this.isCheckArray.length);
				this.isCheckArray.fill(true);
			} else if (value === 0) {
				this.isCheckArray = new Array(this.isCheckArray.length);
				this.isCheckArray.fill(false);
			}
		}
	},
	methods: {
		init() {
			this.conditionData = this.$routerUtil.getParam();
			// this.$routerUtil.clearParam();
			this.fileExpressRefVo = this.conditionData.row.fileExpressRefVo;
			this.isCheckArray = new Array(this.fileExpressRefVo.length);
			this.isCheckArray.fill(false);
		},
		doRefuse() {
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('BillInvalidManage');
		},
		doConfirm(billInvalidForm) {
			this.$refs[billInvalidForm].validate(valid => {
				if (valid) {
					// 补充提单作废申请时 销毁记录 报废保函 的格式限制必须是图片  且是jpg png
					const destructionCheckMsg = this.destruction.name.substring(this.destruction.name.lastIndexOf('.')+1);
					const guaranteeCheckMsg = this.guarantee.name.substring(this.guarantee.name.lastIndexOf('.')+1);
					if (this.destruction.size/(1024*1024) >= 2) {
						this.$message({
							message: this.$t('c_billInvalid.message.uploadDestructionFileSize'),
							type: 'warning',
							center: true
						});
						return;
					}
					if (this.guarantee.size/(1024*1024) >= 2) {
						this.$message({
							message: this.$t('c_billInvalid.message.uploadGuaranteeFileSize'),
							type: 'warning',
							center: true
						});
						return;
					}
					if (destructionCheckMsg.toLowerCase() !== 'jpg' && destructionCheckMsg.toLowerCase() !== 'png' && destructionCheckMsg.toLowerCase() !== 'png') {
						this.$message({
							message: this.$t('c_billInvalid.message.uploadDestructionFileType'),
							type: 'warning',
							center: true
						});
						return;
					}
					if (guaranteeCheckMsg.toLowerCase() !== 'jpg' && guaranteeCheckMsg.toLowerCase() !== 'png' && guaranteeCheckMsg.toLowerCase() !== 'png') {
						this.$message({
							message: this.$t('c_billInvalid.message.uploadGuaranteeFileType'),
							type: 'warning',
							center: true
						});
						return;
					}
					var param = new Object();
					param.blid = this.conditionData.row.id;
					param.type = this.billInvalidForm.invalidRadio;
					param.cause = this.billInvalidForm.applyText;
					var arry = [];
					//文件作废的场景下获取作废的文件ID
					if (this.billInvalidForm.invalidRadio == 0) {
						for (let i = 0; i < this.$refs.fileCheckbox.length; i++) {
							// console.log(this.$refs.fileCheckbox[i]);
							if (this.$refs.fileCheckbox[i].isChecked) {
								if (this.billInvalidForm.invalidRadio == 1) {
									this.$message({
										message: this.$t('c_billInvalid.voidBillOfLadingMassage'),
										type: 'error',
										center: true
									});
									return;
								}
								// console.log(this.$refs.fileCheckbox[i].$attrs.lable);
								arry.push(this.$refs.fileCheckbox[i].$attrs.lable);
							}
						}
					}

					// console.log(arry.length)
					// console.log(arry)
					// console.log(this.billInvalidForm.invalidRadio)
					// 提单文件作废，文件列表不能为空
					if (this.billInvalidForm.invalidRadio === 0 && arry.length === 0) {
						this.$message({
							message: this.$t('c_billInvalid.invalidFileNull'),
							type: 'warning',
							center: true
						});
						return;
					}
					param.id = arry;
					param.destruction = this.destruction;
					param.guarantee = this.guarantee;
					const formData = new FormData();
					for (let key of Object.keys(param)) {
						formData.append(key, param[key]);
					}
					this.$axios({
						method: "put",
						headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
						url: "api/billOfLadings/voidBillOfLadingApply", // 接口地址
						data: formData
					}).then(res => {
						if (res.data.status == 1) {
							this.$message({
								// message: this.$t('c_billInvalid.successMassage'),
								message: this.$t(res.data.message),
								type: 'success',
								center: true
							});
							this.$routerUtil.setParam(this.conditionData.searchForm);
							this.$router.push('BillInvalidManage');
						} else {
							this.$message({
								message: this.$t(res.data.message),
								type: 'error',
								center: true
							});

						}
					}).catch(error => {
						console.log(error);
						this.$message({
							message: 'This is an error message',
							type: 'error',
							center: true
						});
					}); // 失败的返回
				} else {
					console.log('error submit!!');
					return false
				}
			});
		},
		destructionRemove(file, fileList) {
			console.log(file, fileList);
			this.billInvalidForm.destructionList = fileList;
		},
		guaranteeRemove(file, fileList) {
			console.log(file, fileList);
			this.billInvalidForm.guaranteeList = fileList;
		},
		handlePreview(file) {
			console.log(file);
		},
		beforeRemove(file) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		destructionChange(file, fileList) {
			this.billInvalidForm.destructionList = fileList;
			console.log(file);
			this.destruction = file.raw;
		},
		guaranteeChange(file, fileList) {
			this.billInvalidForm.guaranteeList = fileList;
			this.guarantee = file.raw;
		}
	}
}
